"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartBoxCountGroupTimeCard = void 0;
const ChartType_1 = __importDefault(require("@opsbase/lib-chart/ChartType"));
const QueryFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldRegistry"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const useViewActions_1 = __importDefault(require("@opsbase/web-ctrl-view/useViewActions"));
const ChevronLeftIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ChevronLeftIcon"));
const ChevronRightIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ChevronRightIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const IconButton_1 = __importDefault(require("@opsbase/web-ui/IconButton"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem"));
const Select_1 = __importDefault(require("@opsbase/web-ui/Select"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
const ChartBoxTypePicker_1 = __importDefault(require("../ChartBox/ChartBoxTypePicker"));
const CountGroupTimeChart_1 = __importDefault(require("../CountGroupTimeChart"));
const calcIntervalForFilter_1 = require("../helpers/calcIntervalForFilter");
function ChartBoxCountGroupTimeCard(props) {
    const { chart } = props;
    const dt = (0, useDataTree_1.default)();
    const timeDim = QueryFieldRegistry_1.default[chart.config.timeDimension];
    const groupDim = QueryFieldRegistry_1.default[chart.config.otherDimension];
    const { filters, groupBys, highlightedGroups, highlightedDateRange } = (0, useView_1.default)(dt.viewId);
    const { updateChart, toggleHighlightedGroup, toggleHighlightedDateRange, shiftDateFilter } = (0, useViewActions_1.default)(dt.viewId);
    const hIdx = highlightedGroups.findIndex(h => h.queryFieldKey === groupDim.key);
    const highlightedGroup = hIdx >= 0 ? highlightedGroups[hIdx] : undefined;
    const intervalFilter = filters === null || filters === void 0 ? void 0 : filters.find(f => f.queryFieldKey === (timeDim === null || timeDim === void 0 ? void 0 : timeDim.key));
    const interval = (0, react_1.useMemo)(() => (0, calcIntervalForFilter_1.calcIntervalForFilter)(intervalFilter), [intervalFilter]);
    // Handle shifting date range to the left and right
    const handleShiftDate = (0, useCallforward_1.default)(amount => () => shiftDateFilter(timeDim.key, amount), [shiftDateFilter, timeDim.key]);
    // Handle highlighting of a group
    const handleClickValue = (0, react_1.useCallback)(d => {
        toggleHighlightedGroup(dt.groupsById.get(d.y.id));
    }, [dt.groupsById, toggleHighlightedGroup]);
    // Handle highlighting of a date range
    const handleClickDimX = (0, react_1.useCallback)(d => {
        toggleHighlightedDateRange({
            key: timeDim.key,
            from: (0, moment_timezone_1.default)(d.id),
            to: (0, moment_timezone_1.default)(d.id).clone().add(1, interval),
        });
    }, [interval, timeDim.key, toggleHighlightedDateRange]);
    // Handle changing the XGroupBy dimension
    const handleChangeDimension = (0, react_1.useCallback)(dimension => d => {
        updateChart(Object.assign(Object.assign({}, chart), { config: Object.assign(Object.assign({}, chart.config), { [dimension]: d }) }));
    }, [chart, updateChart]);
    // Title Bit
    const titleBit = (0, react_1.useMemo)(() => {
        const groupTitle = highlightedGroup ? highlightedGroup.title : groupDim.label;
        const timeTitle = highlightedDateRange
            ? highlightedDateRange === null || highlightedDateRange === void 0 ? void 0 : highlightedDateRange.from.tz(moment_timezone_1.default.tz.guess()).format('DD MMM')
            : timeDim.label;
        return (react_1.default.createElement(Horizontal_1.default, { gutter: true, centered: true },
            react_1.default.createElement(Pane_1.default, { grow: true }),
            react_1.default.createElement(IconButton_1.default, { tooltip: lib_i18n_1.default.t('go-back-in-time'), icon: react_1.default.createElement(ChevronLeftIcon_1.default, { color: lib_palette_1.default.BlackCoral }), onClick: handleShiftDate(-1) }),
            react_1.default.createElement(ChartDimPicker, { value: { key: groupDim.key, label: groupTitle }, options: groupBys, onChange: handleChangeDimension('otherDimension') }),
            react_1.default.createElement(Text_1.default, { variant: "small" }, "/"),
            react_1.default.createElement(Text_1.default, { variant: "small" }, timeTitle),
            react_1.default.createElement(IconButton_1.default, { tooltip: lib_i18n_1.default.t('go-forwards-in-time'), icon: react_1.default.createElement(ChevronRightIcon_1.default, { color: lib_palette_1.default.BlackCoral }), onClick: handleShiftDate(1) }),
            react_1.default.createElement(Pane_1.default, { grow: true })));
    }, [
        groupBys,
        groupDim.key,
        groupDim.label,
        handleChangeDimension,
        handleShiftDate,
        highlightedDateRange,
        highlightedGroup,
        timeDim.label,
    ]);
    return (0, react_1.useMemo)(() => {
        var _a;
        return (react_1.default.createElement(Vertical_1.default, { centered: true },
            titleBit,
            react_1.default.createElement(Pane_1.default, { grow: true }),
            react_1.default.createElement(CountGroupTimeChart_1.default, { chart: chart, height: 200, highlightXId: (_a = highlightedDateRange === null || highlightedDateRange === void 0 ? void 0 : highlightedDateRange.from) === null || _a === void 0 ? void 0 : _a.toDate().getTime(), highlightYId: highlightedGroup === null || highlightedGroup === void 0 ? void 0 : highlightedGroup.id, onClickValue: handleClickValue, onClickDimX: handleClickDimX }),
            react_1.default.createElement(Pane_1.default, { grow: true }),
            react_1.default.createElement(ChartBoxTypePicker_1.default, { chart: chart, options: [ChartType_1.default.BAR3DGROUP, ChartType_1.default.BAR3DSTACK, ChartType_1.default.AREA3DSTACK] })));
    }, [chart, handleClickDimX, handleClickValue, highlightedDateRange, highlightedGroup, titleBit]);
}
exports.ChartBoxCountGroupTimeCard = ChartBoxCountGroupTimeCard;
exports.default = ChartBoxCountGroupTimeCard;
function ChartDimPicker({ value, options, onChange }) {
    if ((options === null || options === void 0 ? void 0 : options.length) > 1)
        return (react_1.default.createElement(Select_1.default, { small: true, value: value.key, onChange: onChange }, options.map((d) => {
            const queryField = QueryFieldRegistry_1.default[d.queryFieldKey];
            return (react_1.default.createElement(MenuItem_1.default, { key: queryField.key, value: queryField.key }, queryField.label));
        })));
    return (react_1.default.createElement(Text_1.default, { variant: "small", noWrap: true }, value.label || ''));
}
